<template>
    <div class="category_list" @mouseleave="showCategoryTree=false">
        <div class="banner_left_one" @mouseenter="showCategoryTree=true">
            <img src="https://oss-sp-data.oss-cn-hangzhou.aliyuncs.com/img/pc/red/index/index_class.png" alt="">
            <h4>商品分类</h4>
        </div>
        <div class="header_bottom" :class="categoryType&&flag?'index':''" @mouseleave="leaveList " v-if="categoryType ? true : showCategoryTree "    :style="{width:(categoryType ? '920px' : '1200px')}">
            <div class="header_bottom_left">
                <div class="banner_left_list" v-for="(item,index) in categoryList"@mouseleave='' :key="item.categoryId"   @mouseenter="enterList(item)">
                    <div class="banner_left_list_title">
                        <div class="banner_list_title_01">
                            <img v-if="index == 0" :alt="index" src="https://oss-sp-data.oss-cn-hangzhou.aliyuncs.com/img/pc/red/icons/reagentIcon.png">
                            <img v-if="index == 1" :alt="index" src="https://oss-sp-data.oss-cn-hangzhou.aliyuncs.com/img/pc/red/icons/consumablesIcon.png">
                            <img v-if="index == 2" :alt="index" src="https://oss-sp-data.oss-cn-hangzhou.aliyuncs.com/img/pc/others/icons/instrumentIcon.png">
                            <div class="title_01 strokeDiv" @click="toProduct(item.categoryId)">{{item.name}}</div>
                        </div>
                        <img class="arrow_left" v-if="item.children.length" src="https://oss-sp-data.oss-cn-hangzhou.aliyuncs.com/img/pc/red/icons/arrow_left.png" alt="">
                    </div>
                    <div class="banner_left_list2">
                        <div v-for="(keyWordsItem,index) in item.recommendKeyWordList" :key="index" class="banner_left_list2_item strokeDiv" @click="toPagesList(keyWordsItem)">{{keyWordsItem.word}}</div>
                    </div>
                </div>
            </div>
            <div :class="categoryType? 'home_middle_list' : 'banner_middle_list'" v-if="showCategoryTree && showMiddleList">
                <div class="banner_middle_product">
                    <div class="banner_middle_item strokeLink" v-for="(item,index) in allKeyWordsList" :key="index">
                        <div class="title_02" @click="toProduct(item.categoryId)"><span class="strokeDiv" @click="show">{{item.name}}</span></div>
                        <div class="banner_middle_items" v-for="(childrenItem,indexs) in item.children" :key="indexs">
                            <div class="title_03" @click="toProduct(childrenItem.categoryId)"><span @click="show" class="strokeDiv">{{childrenItem.name}}</span></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getIndexCategoryTreeData } from "@/api/common/categoryApi";
export default {
    data() {
        return {
            categoryList: [],
            allKeyWordsList: [],
            showCategoryTree: false,
            showMiddleList: false,
            flag: false,
        };
    },
    props: {
        queryParams: {
            type: Object,
            default: function () {
                return {};
            },
        },
        categoryType: null,
    },
    created() {
        this.initCategoryTreeData();
    },
    methods: {
        initCategoryTreeData() {
            if (!this.categoryList.length) {
                getIndexCategoryTreeData().then((res) => {
                    if (res.success) {
                        this.categoryList = res.data;
                    }
                });
            }
        },
        //鼠标的移入移出事件
        enterList(data) {
            this.showCategoryTree = true;
            this.allKeyWordsList = data.children;
            if (this.allKeyWordsList.length) {
                this.showMiddleList = true;
                this.flag = true;
            } else {
                this.showMiddleList = false;
                this.flag = false;
            }
        },
        leaveList(){
          this.flag=false
          this.showCategoryTree=this.showMiddleList=false
        },
        show() {
            this.showMiddleList = false;
            this.showCategoryTree = false;
        },
        toPagesList(item) {
            window.location.href = item.linkUrl;
        },

        toProduct(categoryId) {
            sessionStorage.setItem("oldFilterList", "");
            this.$router.replace({
                path: "/productList",
                query: { categoryId: categoryId, t: new Date().getTime() },
            });
        },
    },
};
</script>
<style scoped>
.category_list {
    position: relative;
}
.banner_left_one {
    width: 250px;
    height: 40px;
    background-color: #e1251b;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
}
.index{
  z-index: 13 !important;
}
.banner_left_one img {
    width: 15px;
    height: 15px;
    margin-right: 13px;
}
.header_bottom {
    height: 434px;
    display: flex;
    align-items: center;
    position: absolute;
    top: 40px;
    z-index: 10;
}
.header_bottom_left {
    width: 248px;
    height: 434px;
    border: 1px solid #eee;
    background-color: rgba(255, 255, 255, 1);
}
.banner_left_list {
    width: 205px;
    padding: 12px 22px 0;
    cursor: pointer;
}
.banner_left_list_title {
    width: 100%;
    padding: 10px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 15px;
    font-family: Microsoft YaHei;
    font-weight: bold;
}
.banner_list_title_01 {
    display: flex;
    align-items: center;
}
.banner_list_title_01 > img {
    width: 22px;
    height: 22px;
    margin-right: 10px;
}
.banner_left_list_title a {
    color: #333333;
}
.arrow_left {
    width: 18px;
    height: 18px;
    cursor: pointer;
}
.banner_left_list2 {
    width: 100%;
    height: 84px;
    overflow: hidden;
    display: flex;
    align-content: flex-start;
    flex-wrap: wrap;
    font-size: 13px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 21px;
}
.banner_left_list2_item {
    padding: 0 5px;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.banner_middle_list {
    width: calc(100% - 283px);
    height: calc(100% - 32px);
    background-color: #ffffff;
    border: 1px solid #eee;
    border-left: 0px solid #eee;
    padding: 16px;
}
.banner_middle_product {
    width: 100%;
    height: 100%;
    overflow: auto;
}
.banner_middle_item {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    padding-bottom: 20px;
}
.banner_middle_item > .title_02 {
    display: block;
    width: 100%;
    text-align: left;
    margin-bottom: 8px;
    line-height: 20px;
    font-weight: 700;
    color: #333;
    font-size: 15px;
}
.banner_middle_items {
    padding: 0 12px;
    font-size: 13px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 28px;
    cursor: pointer;
    line-height: 22px;
    
}
.home_middle_list {
    width: 611px;
    height: 376px;
    background-color: #ffffff;
    padding: 22px 16px;
    margin: 14px 10px 0;
    z-index: 10;
}
</style>




// WEBPACK FOOTER //
// src/components/pageComponents/categoryList.vue